import { useMemo } from "react";

import { useIconsQuery } from "../../../../../queries/useIconsQuery";
import type { DomainOption } from "../types";

import type { SecondaryDomain } from "./useSecondaryDomainsState";

type UseDomainOptionsParams = {
    activationDomains: string[];
    secondaryDomains: SecondaryDomain[];
};

export const useDomainOptions = ({ activationDomains, secondaryDomains }: UseDomainOptionsParams): DomainOption[] => {
    const { data: primaryIcons } = useIconsQuery(activationDomains, activationDomains.length > 0);

    return useMemo(() => {
        const primaryDomainsSet = new Set(activationDomains);

        const primaryOptions: DomainOption[] = activationDomains.map((domain) => ({
            id: domain,
            label: domain,
            favicon: primaryIcons[domain],
            kind: "primary",
        }));

        const secondaryOptions: DomainOption[] = secondaryDomains
            .filter(({ domain }) => !primaryDomainsSet.has(domain))
            .map(({ domain, icon }) => ({
                id: domain,
                label: domain,
                favicon: icon,
                kind: "secondary",
            }));

        return [...primaryOptions, ...secondaryOptions];
    }, [activationDomains, secondaryDomains, primaryIcons]);
};
